import { useState } from 'react';
import { useForm } from 'react-hook-form';

import { Option } from 'types';

import { TabWrap, SectionType } from 'sections/TabWrap';

import { Select } from 'components/Select';

import { Variant } from './components/Variant';

export function Variants(): React.ReactElement {
  const [value, valueSet] = useState('');
  const { register } = useForm();

  const selectOptions: Option[] = [
    {
      value: 'tipo1',
      label: 'tipo1',
    },
    {
      value: 'tipo2',
      label: 'tipo2',
    },
  ];

  const sections: SectionType[] = [
    {
      id: 1,
      content: <Select options={selectOptions} selectedValue={value} onChange={valueSet} />,
    },
    {
      id: 2,
      content: <Variant register={register} />,
    },
  ];

  return <TabWrap sections={sections} />;
}
